import * as TYPE from '../types';
import { AboutAction, UpdateAboutActionTypes } from '../types';
import { defaultAbout } from './init';

export default (state = {...defaultAbout}, action: UpdateAboutActionTypes) => {

  switch (action.type) {
    case AboutAction.UPDATE_ABOUT:
      return {...action.AboutData};
    default:
      return state;
  }
};
